import ReactOnRails from 'react-on-rails/client';
import PersonsList from '../../app/PersonsList.jsx';

ReactOnRails.register({PersonsList});